import {makeStyles} from '@material-ui/core'

export default makeStyles(theme => ({
  rotate90: {
    transform: 'rotate(90deg)',
  },
  button: {
    width: 36,
    height: 36,
    padding: 0,
    '&:not(:first-child)': {
      marginLeft: theme.spacing(1),
    },
  },
  selectedButton: {
    boxShadow: `inset 0 0 0 1px ${theme.palette.divider}`,
  },
}))
